// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7a93c43b","513":"928d8cd2","703":"c475ce08","787":"97339a5d"}[chunkId] + ".chunk.js";
};